import React from "react";

import { MemberAvatar } from "@common/memberAvatar";
import { Email } from "./email";
import { Authentication } from "./authentication";
import { Planzone } from "./planzone";
import { Project } from "./project";
import { Unavailability } from "./unavailability";
import { Zone } from "./zone";
import { Activity } from "./activity";
import { Portfolio } from "./portfolio";
import { Props } from "./types";
import styles from "./styles.scss";

function Log({ log }: Props) {
  const creationDate = new Date(log.createdDate);

  return (
    <div className={styles.log}>
      <div className={styles.body}>
        <div className={styles.author}>
          <div className={styles.avatar}>
            <MemberAvatar
              name={log.author.name}
              avatarUrl={log.author.avatarUrl}
            />
          </div>
          <div className={styles.infoBubble}>
            <p>{log.author.name}</p>
          </div>
        </div>
        {log.logType === "AUTHENTICATION" ? (
          <Authentication log={log} />
        ) : log.logType === "EMAIL" ? (
          <Email log={log} />
        ) : log.logType === "PLANZONE" ? (
          <Planzone log={log} />
        ) : log.logType === "PROJECT" ? (
          <Project log={log} />
        ) : log.logType === "UNAVAILABILITY" ? (
          <Unavailability log={log} />
        ) : log.logType === "ZONE" ? (
          <Zone log={log} />
        ) : log.logType === "PORTFOLIO" ? (
          <Portfolio log={log} />
        ) : (
          <Activity log={log} />
        )}
      </div>
      <p className={styles.creationDate}>
        {creationDate.toLocaleDateString()} {creationDate.getHours()}h
        {creationDate.getMinutes().toString().padStart(2, "0")}
      </p>
    </div>
  );
}

export { Log };
